/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Button} from '@dnb/eufemia/src';
import GithubLogo from 'Docs/contribute/assets/github-logo.js';
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    h2: "h2",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Demo Apps"
    }), "\n", _jsx(_components.p, {
      children: "The purpose of having Eufemia Demos is that you as a developer can see the code and understand Eufemia and be inspired - and not least, give you a good start."
    }), "\n", _jsx(Button, {
      href: "https://github.com/dnbexperience/eufemia-demo/",
      size: "large",
      target: "_blank",
      text: "Get a Clone on GitHub",
      icon: GithubLogo
    }), "\n", _jsx(_components.h2, {
      children: "Form Demo #1"
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.a, {
        href: "https://github.com/dnbexperience/eufemia-demo/blob/main/src/form-demos/form-demo-01.js",
        children: "code"
      }), " for this little demo app is to show how to make a form layout with Eufemia. It is mainly to demonstrate the visual part, but includes also some event handling - but no state management."]
    }), "\n", _jsx(Button, {
      href: "/uilib/demos/eufemia-demo/form-demo-01",
      target: "_blank",
      text: "View Demo",
      variant: "secondary",
      className: "margin-bottom"
    }), "\n", _jsx("div", {
      className: "example-box center margin-bottom",
      children: _jsx("a", {
        href: "https://raw.githubusercontent.com/dnbexperience/eufemia-demo/main/misc/screenshot_comparison.png",
        target: "_blank",
        children: _jsx("img", {
          width: "100%",
          alt: "Preview of Demo App",
          src: "https://raw.githubusercontent.com/dnbexperience/eufemia-demo/main/misc/screenshot_comparison.png"
        })
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
